import { Button } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SharePop from "../../components/common/shareLivestream";
import Modal from "../../components/Modal/Modal";
import {
    fetchPaymentConfigRequest,
    getCategoryRequest,
} from "../../store/shopping/shopping.actions";
import { getPrivateLoungeUserRequest } from "../../store/user/privatelounge/privatelounge.actions";
import { getUserPrivateLounge } from "../../store/user/privatelounge/privatelounge.selector";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
    unfollowUserRequest,
} from "../../store/user/user.actions";
import UserAPI from "../../store/user/user.api";
import {
    getImage,
    getOtherUserProfile,
    getUserProfile,
} from "../../store/user/user.selector";
import PublicHall from "./PublicHall";
import SuggestedUser from "./suggested_user";

const ViewOtherProfile = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [selectedCategory, setSelectedCategory] = useState({});
    const history = useNavigate();
    const [disabled, setDisabled] = useState(false);
    const [uploadModal, setUploadModal] = useState(false);
    const [profileModal, setProfileModal] = useState(false);
    const scrollRef = useRef(null);

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    useEffect(() => {
        dispatch(fetchPaymentConfigRequest());
        dispatch(getCategoryRequest());
    }, []);

    const { userProfile, userPrivateLounge, curUserProfile } = useSelector(
        (state) => {
            return {
                userProfile: getOtherUserProfile(state),
                curUserProfile: getUserProfile(state),
                userPrivateLounge: getUserPrivateLounge(state),
            };
        }
    );

    useEffect(() => {
        if (userProfile && userProfile.id) {
            setDisabled(false);
            dispatch(
                getPrivateLoungeUserRequest({
                    userId: userProfile.id,
                })
            );
        }
    }, [userProfile]);

    const cancelSubscription = (expiredDate) => {
        UserAPI.UnsubscribeUser({
            creator: userProfile.id,
        })
            .then((X) => {
                Swal.fire({
                    title: "Cancel Subscription",
                    text: `Your subscription will be cancel at the end of your billing period on ${expiredDate}. 
				You can change your mind anytime before this date.`,
                    icon: "question",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonText: "Proceed",
                    showConfirmButton: true,
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                            title: "Cancel Subscription",
                            text: `Content will be available until ${expiredDate}.`,
                            icon: "success",
                            showCancelButton: true,
                            cancelButtonText: "Close",
                            showConfirmButton: false,
                            customClass: {
                                cancelButton: "order-1 right-gap",
                                confirmButton: "order-2",
                                denyButton: "order-3",
                            },
                        }).then((result) => {
                            if (result.isDismissed) {
                                dispatch(
                                    fetchOtherUserProfileRequest(
                                        userProfile.id,
                                        null
                                    )
                                );
                            }
                        });
                    }
                });
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const shareUrl = process.env.REACT_APP_URL + "/" + userProfile.userName;
    return (
        <div className=" h-full overflow-hidden">
            <div className="flex h-full">
                <div className="w-full md:flex-1 my-2 sm:my-4 mx-2 sm:mx-4 md:mx-8 bg-white rounded-lg max-h-full flex flex-col">
                    <div className="">
                        <div className="bg-orange-color px-2 sm:px-5 pt-3 sm:pt-4 rounded-tl-lg rounded-tr-lg">
                            <div className="flex justify-end pr-5 md:pr-10"></div>
                            <div className="px-3.5 py-2.5 bg-white rounded-2xl flex gap-x-3 md:gap-x-10 relative -bottom-[52px] z-10 profile-shadow mr-2 sm:mr-4 md:mr-0">
                                <div className="grid grid-cols-3 items-center md:grid-cols-5 flex-1">
                                    <div className="ml-auto md:m-0 shrink-0 col-span-2">
                                        <div className="flex items-center">
                                            <img
                                                src={getImage(
                                                    userProfile.avatar
                                                        .attachments
                                                )}
                                                className="w-20 h-20 rounded-full mb-1.5"
                                                alt=""
                                            />
                                            <div className="relative pl-4">
                                                {userProfile.role === "Pro" && (
                                                    <button className="absolute p-2 py-1 text-sm font-bold text-white bg-orange-color block rounded-lg right-[-50px] top-[-5px]">
                                                        Pro
                                                    </button>
                                                )}
                                                <h3 className="text-sm font-medium text-ebony-color">
                                                    {userProfile.fullName}
                                                </h3>
                                                <p className="text-sm text-ebony-color/70">
                                                    @{userProfile.userName}
                                                </p>
                                                <div className="py-1 px-2 bg-[#F7F0FF] rounded-md flex gap-x-2 mb-1 w-fit">
                                                    <span>
                                                        <svg
                                                            width="11"
                                                            height="11"
                                                            viewBox="0 0 11 11"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M8.35577 8.40265C8.03598 8.72244 7.47788 9.28054 6.94148 9.81694C6.16043 10.598 4.89428 10.598 4.11323 9.81696C3.58758 9.29131 3.03731 8.74104 2.69892 8.40265C1.13682 6.84055 1.13682 4.30789 2.69892 2.74579C4.26101 1.18369 6.79367 1.18369 8.35577 2.74579C9.91787 4.30789 9.91787 6.84055 8.35577 8.40265Z"
                                                                stroke="#7900F8"
                                                                strokeWidth="1.15535"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.02734 5.57422C7.02734 6.40265 6.35577 7.07422 5.52734 7.07422C4.69892 7.07422 4.02734 6.40265 4.02734 5.57422C4.02734 4.74579 4.69892 4.07422 5.52734 4.07422C6.35577 4.07422 7.02734 4.74579 7.02734 5.57422Z"
                                                                stroke="#7900F8"
                                                                strokeWidth="1.15535"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <p className="text-extraSmall text-black-80 font-medium">
                                                        {
                                                            userProfile.country
                                                                .isoCode
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countFollower}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Followers
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countFollowing}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Following
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countSubscriber}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Subscribers
                                        </p>
                                    </div>
                                </div>
                                <div className="flex justify-end items-start pt-2.5 md:pr-6">
                                    <button
                                        onClick={() =>
                                            history(
                                                `/${userProfile.userName}/profile/shop`
                                            )
                                        }
                                        className="p-[7px] w-full rounded-lg text-white text-md flex items-center justify-center border bg-orange-color capitalize"
                                    >
                                        <span>
                                            <svg
                                                width="18"
                                                height="16"
                                                viewBox="0 0 18 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.1252 14.75V9.125C10.1252 8.97582 10.1845 8.83274 10.29 8.72725C10.3954 8.62176 10.5385 8.5625 10.6877 8.5625H12.9377C13.0869 8.5625 13.23 8.62176 13.3355 8.72725C13.4409 8.83274 13.5002 8.97582 13.5002 9.125V14.75M10.1252 14.75H1.77021M10.1252 14.75H13.5002M13.5002 14.75H16.2302M15.1877 14.75V6.01175C15.4867 5.83918 15.7419 5.60014 15.9337 5.31313C16.1254 5.02613 16.2486 4.69884 16.2936 4.35661C16.3386 4.01438 16.3043 3.66638 16.1933 3.33954C16.0823 3.01269 15.8976 2.71577 15.6535 2.47175L14.761 1.58C14.5502 1.36896 14.2642 1.25026 13.966 1.25H4.03371C3.73544 1.25026 3.44948 1.36896 3.23871 1.58L2.34696 2.471C2.10338 2.7153 1.91917 3.01228 1.80851 3.33903C1.69785 3.66578 1.6637 4.01358 1.7087 4.35561C1.7537 4.69765 1.87665 5.02478 2.06806 5.31178C2.25947 5.59879 2.51423 5.83801 2.81271 6.011M2.81271 14.7493V6.0125C3.26272 6.27199 5.11287 5.45907 5.62549 5.375C7.87549 7.25 11.9627 6.01775 12.3752 5.5505C12.7189 5.94001 13.1867 6.19867 13.6993 6.2826C14.2119 6.36653 14.7378 6.27057 15.1877 6.011"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        &nbsp;
                                        <span>Shop</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-4 overflow-y-auto bg-white flex-grow">
                        <div className="px-4 pt-20 mb-[17px] pl-5">
                            <p className="text-sm text-black-60 text-left mb-5">
                                {userProfile.descriptions}
                            </p>
                            <div className="flex justify-start items-start">
                                <Button
                                    variant={
                                        !userProfile.isFollowing
                                            ? "contained"
                                            : "outlined"
                                    }
                                    color={
                                        !userProfile.isFollowing
                                            ? "primary"
                                            : "default"
                                    }
                                    className="mr-2"
                                    disabled={disabled}
                                    onClick={() => {
                                        setDisabled(true);
                                        userProfile.isFollowing
                                            ? dispatch(
                                                  unfollowUserRequest({
                                                      following: userProfile.id,
                                                  })
                                              )
                                            : dispatch(
                                                  followUserRequest({
                                                      following: userProfile.id,
                                                  })
                                              );
                                        setTimeout(() => {
                                            dispatch(
                                                fetchOtherUserProfileRequest(
                                                    userProfile.id,
                                                    history
                                                )
                                            );
                                        }, 1000);
                                    }}
                                >
                                    <span className="text-bold">
                                        {userProfile.isFollowing
                                            ? "Following"
                                            : "Follow"}
                                    </span>
                                </Button>
                                <Button
                                    variant={"outlined"}
                                    color={
                                        !userProfile.isSubscribe
                                            ? "primary"
                                            : "default"
                                    }
                                    className="mr-2"
                                    disabled={!userPrivateLounge}
                                    onClick={() => {
                                        userProfile.isSubscribe
                                            ? cancelSubscription(
                                                  moment(
                                                      userProfile
                                                          .subscribedFound
                                                          .expiredTime
                                                  ).format("DD/MM/YYYY")
                                              )
                                            : userPrivateLounge
                                            ? history(
                                                  "/page/subscription_payment"
                                              )
                                            : console.log("No Fees");
                                    }}
                                >
                                    <span className="text-bold">
                                        {userProfile.isSubscribe &&
                                        userPrivateLounge
                                            ? "Subscribed / " +
                                              userPrivateLounge.currencySubscription +
                                              " " +
                                              userPrivateLounge.monthlySubscription
                                            : userPrivateLounge
                                            ? "Subscribe / " +
                                              userPrivateLounge.currencySubscription +
                                              " " +
                                              userPrivateLounge.monthlySubscription
                                            : "Subscribe"}
                                    </span>
                                </Button>
                                <Button
                                    variant="outlined"
                                    className="mr-2"
                                    onClick={() =>
                                        history("/page/chat", {
                                            state: {
                                                userId: userProfile.id,
                                            },
                                        })
                                    }
                                >
                                    Chatroom
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() =>
                                        history("/page/inbox", {
                                            state: {
                                                userId: userProfile.id,
                                            },
                                        })
                                    }
                                >
                                    Inmail
                                </Button>
                                <Button
                                    onClick={() => setProfileModal(true)}
                                    className="mt-2"
                                >
                                    <br />
                                    <svg
                                        width="25"
                                        height="7"
                                        className="cursor-pointer"
                                        viewBox="0 0 25 7"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="3.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                        <circle
                                            cx="12.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                        <circle
                                            cx="21.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>
                        <div className="px-4 bg-white shrink-0">
                            <div
                                onWheel={(e) => scrollH(e)}
                                ref={scrollRef}
                                className="w-full overflow-scroll no-scrollbar"
                            >
                                <ul className="w-full flex items-center space-x-2 pb-[5px] border-b border-black-10">
                                    <li>
                                        <NavLink
                                            to={`/${userProfile.userName}/profile/public-hall`}
                                            className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${
                                                location.pathname ==
                                                "/" + userProfile.userName
                                                    ? "active"
                                                    : ""
                                            }`}
                                        >
                                            Public Hall
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={`/${userProfile.userName}/profile/private-lounge`}
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            Private Lounge
                                        </NavLink>
                                    </li>
                                    {/* <li>
                                        <NavLink
                                            to={`/${userProfile.userName}/profile/meeting-room`}
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            Meeting Room
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={`/${userProfile.userName}/profile/vip-circle`}
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            VIP Circle
                                        </NavLink>
                                    </li> */}
                                    <li>
                                        <NavLink
                                            to={`/${userProfile.userName}/profile/recordings`}
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            My page
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="pt-4">
                            {location.pathname.indexOf("profile") > -1 ? (
                                <Outlet />
                            ) : (
                                <PublicHall />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={`w-[300px] bg-white px-4 overflow-y-auto overflow-hidden  hidden lg:block`}
                >
                    <div className="h-full flex flex-col justify-between">
                        <SuggestedUser />

                        <div className="pt-1 pb-4 border-t border-black-10 text-center">
                            <p className="text-sm font-medium text-black-30">
                                &copy; 2022 Ulalive Inc
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Modal  */}
            <Modal show={uploadModal} onClose={() => setUploadModal(false)}>
                <div className="w-full xs:w-[360px]">
                    <div className="mb-2.5">
                        <h3 className="text-base font-bold text-ebony-color">
                            Upload banner
                        </h3>
                    </div>

                    <div className="rounded-md border border-black-10 py-11 cursor-pointer flex justify-center items-center text-black-10 hover:text-orange-color mb-2.5">
                        <svg
                            width="31"
                            height="31"
                            className="stroke-current"
                            viewBox="0 0 31 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15.4993 0.916016C23.5537 0.916016 30.0827 7.44497 30.0827 15.4993C30.0827 23.5537 23.5537 30.0827 15.4993 30.0827C7.44497 30.0827 0.916016 23.5537 0.916016 15.4993C0.916016 7.44497 7.44497 0.916016 15.4993 0.916016ZM15.4993 8.20768C15.235 8.20769 14.9797 8.30341 14.7805 8.47713C14.5813 8.65086 14.4518 8.89083 14.4158 9.15268L14.4056 9.30143V14.4056H9.30143C9.02431 14.4057 8.75756 14.511 8.55507 14.7001C8.35258 14.8893 8.22945 15.1483 8.21056 15.4248C8.19167 15.7013 8.27843 15.9746 8.45331 16.1896C8.62819 16.4045 8.87815 16.5451 9.15268 16.5829L9.30143 16.5931H14.4056V21.6973C14.4057 21.9744 14.511 22.2411 14.7001 22.4436C14.8893 22.6461 15.1483 22.7692 15.4248 22.7881C15.7013 22.807 15.9746 22.7203 16.1896 22.5454C16.4045 22.3705 16.5451 22.1205 16.5829 21.846L16.5931 21.6973V16.5931H21.6973C21.9744 16.593 22.2411 16.4877 22.4436 16.2986C22.6461 16.1094 22.7692 15.8504 22.7881 15.5739C22.807 15.2974 22.7203 15.0241 22.5454 14.8091C22.3705 14.5942 22.1205 14.4536 21.846 14.4158L21.6973 14.4056H16.5931V9.30143C16.5931 9.01135 16.4779 8.73315 16.2727 8.52803C16.0676 8.32292 15.7894 8.20768 15.4993 8.20768Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>

                    <div className="">
                        <p className="text-sm font-medium text-orange-color mb-8">
                            *Required ratio 1:5.7{" "}
                        </p>
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setUploadModal(false)}
                                type="submit"
                                className="py-2.5 px-5 text-sm rounded-lg capitalize border border-orange-color bg-orange-color font-bold text-white"
                            >
                                save
                            </button>
                            <button
                                onClick={() => setUploadModal(false)}
                                className="py-2.5 px-5 text-sm rounded-lg capitalize border border-black-10 bg-white font-medium text-black-50"
                            >
                                cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Share Profile Modal  */}
            <Modal show={profileModal} onClose={() => setProfileModal(false)}>
                <SharePop
                    onClose={() => setProfileModal(false)}
                    shareUrl={shareUrl}
                    title={userProfile.fullName}
                    subTitle={userProfile.userName}
                    image={getImage(userProfile.avatar.attachments)}
                    heading="Share Profile"
                />
            </Modal>
        </div>
    );
};

export default ViewOtherProfile;
